import { AnimatePresence, AnimateSharedLayout, motion } from "framer-motion";
import React, { useState } from "react";
import { container, item, title, title2 } from "./animation";
import { ImageComp } from "./ImageComp";
import { ShowDcomp } from "./ShowDcomp";
import { ShowDcomp2 } from "./ShowDcomp2";

const nonMutable = {
  thumb: "",
  title: "",
  state: false,
  body: "",
  pal: [],
  images: [],
  layoutId: "",
};
function DesignsLists({ images }) {
  const [Designs, setDesigns] = useState({ ...nonMutable });
  return (
    <>
      <div className="designs--list--wrapper">
        <AnimateSharedLayout type="crossfade">
          <motion.ul
            className="main--designs--ul"
            variants={container}
            initial="initial"
            animate="animate"
          >
            {images.map((i) => {
              return (
                <motion.li
                  key={i.id}
                  layoutId={i.title}
                  variants={item}
                  exit={{
                    y: 100,
                    opacity: 0,

                    transition: { duration: 0.4, ease: "easeIn" },
                  }}
                  onTap={() => {
                    setDesigns({
                      state: true,
                      thumb: i.thumbImage,
                      body: i.body,
                      pal: [...i.palette],
                      title: i.title,
                      images: [...i.showImages],
                      layoutId: i.title,
                    });
                  }}
                  tabIndex="0"
                >
                  <div className="thumbnail--area">
                    <ImageComp
                      image={i.thumbImage}
                      alt={`${i.title}--thumbnail`}
                    />
                  </div>
                  <motion.h2
                    variants={Designs.state ? title : title2}
                    initial="initial"
                    animate="animate"
                  >
                    {i.title}
                  </motion.h2>
                </motion.li>
              );
            })}
          </motion.ul>
          {Designs.state && (
            <AnimatePresence>
              <ShowDcomp
                state={Designs}
                setState={setDesigns}
                nonMutable={nonMutable}
              />
            </AnimatePresence>
          )}
        </AnimateSharedLayout>

        {Designs.state && (
          <AnimatePresence exitBeforeEnter>
            <ShowDcomp2
              state={Designs}
              setState={setDesigns}
              nonMutable={nonMutable}
            />
          </AnimatePresence>
        )}
      </div>
    </>
  );
}

export default DesignsLists;
